module.exports = __webpack_public_path__ + "img/refund-zl.e4a338a4.svg";